import { SavingEntry } from '../types';

export const calculateTotalSavings = (entries: SavingEntry[]): number => {
  const oneTimeSavings = entries
    .filter(entry => entry.type === 'one-time')
    .reduce((total, entry) => total + entry.amount, 0);
    
  const annualRecurringSavings = entries
    .filter(entry => entry.type === 'recurring')
    .reduce((total, entry) => total + (entry.amount * 12), 0); // Monthly recurring * 12 for annual
    
  return oneTimeSavings + annualRecurringSavings;
};

export const calculateOneTimeSavings = (entries: SavingEntry[]): number => {
  return entries
    .filter(entry => entry.type === 'one-time')
    .reduce((total, entry) => total + entry.amount, 0);
};

export const calculateMonthlyRecurringSavings = (entries: SavingEntry[]): number => {
  return entries
    .filter(entry => entry.type === 'recurring')
    .reduce((total, entry) => total + entry.amount, 0);
};

export const calculateAnnualProjection = (entries: SavingEntry[]): number => {
  const monthlyRecurring = calculateMonthlyRecurringSavings(entries);
  return monthlyRecurring * 12;
};